export const AGENTIC_CRASH_OPERATION = 'AgenticCrash';
export const VIEWER_CRASH_METRIC = 'ViewerCrash';

export const AGENTIC_SAML_HEARTBEAT_OPERATION = 'AgenticSAMLHeartbeat';
export const SAML_HEARTBEAT_ERROR_METRIC = 'OpError';
